import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Proposal Attributes',
      type: 'details',
      watch: {
        '[]': [
          {
            '{}': {
              alias: 'save.proposal',
            },
          },
        ],
      },
      content: {
        '{}': {
          fields: {
            '@': 'proposalFields',
          },
          columnCount: 3,
        },
      },
      overflowActions: {
        '[]': [
          {
            '{}': {
              icon: 'atn-icon atn-link',
              name: 'Edit',
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      widget: {
                        '{}': {
                          alias: 'edit.proposal.modal',
                        },
                      },
                      variables: {
                        '{}': {
                          proposalId: {
                            '@$': 'proposalId',
                          },
                        },
                      },
                    },
                  },
                  operation: 'ui.modal',
                },
              },
            },
          },
        ],
      },
    },
  },
  variables: {
    proposalId: '?1',
  },
  subqueries: {
    proposalFields: {
      filter: {
        '=': [
          {
            '@.': '!id',
          },
          {
            '@$': 'proposalId',
          },
        ],
      },
      target: 'ent:!proposals:!proposal',
      quantity: 1,
      selection: {
        '[]': [
          {
            '{}': {
              id: 'name',
              meta: {
                '{}': {
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!proposals#!proposal:!name',
                    },
                  },
                },
              },
              value: {
                '@.': '!name',
              },
              readonly: true,
            },
          },
          {
            '{}': {
              id: 'status',
              meta: {
                '{}': {
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!proposals#!proposal:!status',
                    },
                  },
                },
              },
              value: {
                '@.': '!status',
              },
              readonly: true,
            },
          },
          {
            '{}': {
              id: 'organization',
              meta: {
                '{}': {
                  direct: {
                    '{}': {
                      name: 'Organization',
                      type: 'TEXT',
                    },
                  },
                },
              },
              value: {
                '@': 'organizationName',
              },
              readonly: true,
            },
          },
          {
            '{}': {
              id: 'code',
              meta: {
                '{}': {
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!proposals#!proposal:!code',
                    },
                  },
                },
              },
              value: {
                '@.': '!code',
              },
              readonly: true,
            },
          },
          {
            '{}': {
              id: 'amount',
              meta: {
                '{}': {
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!proposals#!proposal:!amount',
                    },
                  },
                },
              },
              value: {
                '@.': '!amount',
              },
              readonly: true,
            },
          },
          {
            '{}': {
              id: 'client',
              meta: {
                '{}': {
                  direct: {
                    '{}': {
                      name: 'Client',
                      type: 'TEXT',
                    },
                  },
                },
              },
              value: {
                '@': 'clientName',
              },
              readonly: true,
            },
          },
          {
            '{}': {
              id: 'id',
              meta: {
                '{}': {
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!proposals#!proposal:!id',
                    },
                  },
                },
              },
              value: {
                '@.': '!id',
              },
              readonly: true,
            },
          },
          {
            '{}': {
              id: 'dueDate',
              meta: {
                '{}': {
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!proposals#!proposal:!due_date',
                    },
                  },
                },
              },
              value: {
                '@.': '!due_date',
              },
              readonly: true,
            },
          },
          {
            '{}': {
              id: 'orgOffering',
              meta: {
                '{}': {
                  direct: {
                    '{}': {
                      name: 'Organization Offering',
                      type: 'TEXT',
                    },
                  },
                },
              },
              value: {
                '@': 'orgOfferingName',
              },
              readonly: true,
            },
          },
        ],
      },
      subqueries: {
        clientName: {
          ref: {
            attr: 'attr:ent#!proposals#!proposal:!client',
          },
          target: 'ent:!clients:!client',
          selection: {
            '@.': '!name',
          },
        },
        orgOfferingName: {
          ref: {
            attr: 'attr:ent#!proposals#!proposal:!org_offering',
          },
          target: 'ent:!org_offering:!entry',
          selection: {
            '@.': '!name',
          },
        },
        organizationName: {
          ref: {
            attr: 'attr:ent#!proposals#!proposal:!org',
          },
          target: 'dim::!org',
          selection: {
            '@.': '!name',
          },
        },
      },
    },
  },
}
